import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDI } from '@/di/DIContext'

export function useSetNickname() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { accountService, sessionService } = useDI()

  const [nickname, setNicknameValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const agentId = sessionService.getAgentId()

  const handleSetNickname = async () => {
    setIsLoading(true)
    setErrorMessage('')
    try {
      await accountService.updateNickname(agentId!, nickname)
      await queryClient.invalidateQueries({
        queryKey: ['userProfile', agentId],
      })
      navigate('/', { replace: true })
    } catch (error) {
      const err = error as Error
      setErrorMessage(err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const setNickname = (value: string) => {
    setNicknameValue(value)
    if (errorMessage) setErrorMessage('')
  }

  return {
    nickname,
    setNickname,
    isLoading,
    errorMessage,
    handleSetNickname,
  }
}
